import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Navbar from "../../../Shared/Navbar/Navbar";
import { baseURL } from "../../../Apiservices/Api";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaTrash, FaEdit, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const LeadStatus = () => {
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);
  const [name, setName] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [editIsPrimary, setEditIsPrimary] = useState(true);
  const [editParentId, setEditParentId] = useState(null);

  const [expanded, setExpanded] = useState({});
  const [addingSecondaryFor, setAddingSecondaryFor] = useState(null);
  const [secondaryName, setSecondaryName] = useState("");

  const [activeTab, setActiveTab] = useState("lead"); // ✅ tab state

  const inputRef = useRef(null);

  useEffect(() => {
    fetchStatuses();
  }, []);

  const fetchStatuses = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/lead-status/all`);
      setStatusList(res.data);
    } catch (error) {
      console.error("Error fetching statuses:", error);
    }
  };

  useEffect(() => {
    if (addingSecondaryFor && inputRef.current) {
      inputRef.current.focus();
    }
  }, [addingSecondaryFor]);

  const toggleExpand = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleAddOrUpdate = async () => {
    if (!name.trim()) return;

    try {
      if (editingId) {
        await axios.put(`${baseURL}/api/lead-status/${editingId}`, {
          name,
          is_primary: editIsPrimary,
          parent_id: editIsPrimary ? null : editParentId,
        });
      } else {
        await axios.post(`${baseURL}/api/lead-status`, {
          name,
          is_primary: true,
        });
      }

      resetForm();
      fetchStatuses();
    } catch (error) {
      console.error("Error saving status:", error);
    }
  };

  const handleAddSecondary = async (parentId) => {
    if (!secondaryName.trim()) return;

    try {
      await axios.post(`${baseURL}/api/lead-status`, {
        name: secondaryName,
        is_primary: false,
        parent_id: parentId,
      });

      setSecondaryName("");
      setAddingSecondaryFor(null);
      fetchStatuses();
    } catch (error) {
      console.error("Error adding secondary:", error);
    }
  };

  const handleEdit = (row) => {
    setName(row.name);
    setEditingId(row.id);
    setEditIsPrimary(row.is_primary);
    setEditParentId(row.parent_id || null);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseURL}/api/lead-status/${id}`);
      fetchStatuses();
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };

  const resetForm = () => {
    setName("");
    setEditingId(null);
    setEditIsPrimary(true);
    setEditParentId(null);
  };

  const groupedData = statusList
    .filter((item) => item.is_primary)
    .map((primary) => ({
      ...primary,
      children: statusList.filter(
        (child) => child.parent_id === primary.id
      ),
    }));

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />

      <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>

        {/* 🔥 TABS (SAME AS PAYMENTS PAGE) */}
        <div className="payments-tabs">
          <button
            className={activeTab === "lead" ? "active" : ""}
            onClick={() => setActiveTab("lead")}
          >
            Lead Status
          </button>

          <button
            className={activeTab === "opportunity" ? "active" : ""}
            onClick={() => {
              setActiveTab("opportunity");
              navigate("/a-lead-opp-status"); // 👉 change if needed
            }}
          >
            Opportunity Status
          </button>
        </div>

        <h1>Lead Status</h1>

        {/* 🔹 Add Primary */}
        <div className="container mt-3">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Primary Status"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />

                <button
                  className="btn btn-success px-3"
                  onClick={handleAddOrUpdate}
                >
                  {editingId ? "Update" : "Add"}
                </button>

                {editingId && (
                  <button
                    className="btn btn-secondary px-3"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* 🔥 CRM UI */}
        <div className="container mt-4">
          {groupedData.map((primary) => (
            <div key={primary.id} className="card mb-3 shadow-sm">

              <div
                className="card-header d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer", background: "#f8f9fa" }}
                onClick={() => toggleExpand(primary.id)}
              >
                <strong>{primary.name}</strong>

                <div>
                  <FaPlus
                    style={{ marginRight: 10, cursor: "pointer", color: "green" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpanded((prev) => ({
                        ...prev,
                        [primary.id]: true,
                      }));
                      setAddingSecondaryFor(primary.id);
                    }}
                  />

                  <FaEdit
                    style={{ marginRight: 10, cursor: "pointer", color: "#ff9966" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(primary);
                    }}
                  />

                  <FaTrash
                    style={{ cursor: "pointer", color: "#ff9966" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(primary.id);
                    }}
                  />

                  <span style={{ marginLeft: 10 }}>
                    {expanded[primary.id] ? "▼" : "▶"}
                  </span>
                </div>
              </div>

              {expanded[primary.id] && (
                <div className="card-body p-2">

                  {addingSecondaryFor === primary.id && (
                    <div className="d-flex mb-2 px-2">
                      <input
                        ref={inputRef}
                        type="text"
                        className="form-control me-2"
                        placeholder="Enter Secondary Status"
                        value={secondaryName}
                        onChange={(e) => setSecondaryName(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleAddSecondary(primary.id);
                          }
                        }}
                      />
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => handleAddSecondary(primary.id)}
                      >
                        Add
                      </button>
                    </div>
                  )}

                  {primary.children.map((child) => (
                    <div
                      key={child.id}
                      className="d-flex justify-content-between align-items-center border-bottom py-2 px-2"
                    >
                      <span style={{ marginLeft: "20px" }}>
                        ↳ {child.name}
                      </span>

                      <div>
                        <FaEdit
                          style={{ marginRight: 10, cursor: "pointer", color: "#ff9966" }}
                          onClick={() => handleEdit(child)}
                        />
                        <FaTrash
                          style={{ cursor: "pointer", color: "#ff9966" }}
                          onClick={() => handleDelete(child.id)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default LeadStatus;